/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * The component to show message for lack of table data
 *
 * @author Anton Panasenko
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.0.0
 */

import { Fragment, memo } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectTranslationCommon } from '../../modules/internationalization/intSelectors';
import { ICommonTranslation } from '../../modules/internationalization/types';
import { IRootReducer } from '../../reducers/rootReducer';
import { ImgStatusError, StatusStyled } from '../common/Block/Img';
import { makeSelectorTableMessage } from './selectors/tableSelectors';

export interface ITableNoDataPropsLocale {
    isDataLoaded: boolean;
}

/**
 * @description Render message No data.
 */
export const TableNoData = ({ errorMessage, isDataLoaded, translation }: ITableNoDataPropsLocale & IConnectedProps) => (
    <Fragment>
        {
            !!(errorMessage || isDataLoaded) && (
                <StatusStyled>
                    <ImgStatusError/>
                    <div className="status__title">
                        {errorMessage ? translation.commonTable.error : translation.commonTable.noData}
                    </div>
                </StatusStyled>
            )
        }
    </Fragment>
);

export interface IConnectedProps {
    errorMessage: string;
    translation: ICommonTranslation;
}

const mapStateToProps = () => createStructuredSelector<IRootReducer, IConnectedProps>({
    errorMessage: makeSelectorTableMessage(),
    translation: makeSelectTranslationCommon(),
});

export default connect(mapStateToProps)(memo(TableNoData));
